import { format, parseISO } from 'date-fns'

export const formatStatusText = (card: APIResponse.DME.MemberCard) => {
  const formattedDate = format(parseISO(card.createdAt), 'MMM d, yyyy')
  return `${card.readableSize} | ${formattedDate}`
}
